import script from "./user-detail.vue?vue&type=script&lang=ts&setup=true"
export * from "./user-detail.vue?vue&type=script&lang=ts&setup=true"

import "./user-detail.vue?vue&type=style&index=0&id=dddd40d0&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dddd40d0"]])

export default __exports__